export default __webpack_public_path__ + "static/media/gallery_02.5b708c00.jpg";